// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"FormNavigation_buttonWrapper__1ewEE","button":"FormNavigation_button__2T9fJ","enable":"FormNavigation_enable__1hD05"};